/**
 * @author caijianjia
 * @date 2024/6/1 9:07 下午
 */

import axios from 'axios'
// const base = 'http://shuanghua.hktd18h.my08w.com/index.php'
// const base = 'http://1e27689s36.goho.co:22392/index.php'
// const base = 'http://caijiajia100.vicp.cc:23740/index.php'
const base = '/index.php'

// 获取banner
export function getBanner ({ type = 1 }) {
  return axios.get(`${base}?m=Home&c=Index&a=getBanner`)
}

// 获取公共数据
export function comm () {
  return axios.get(`${base}?m=Home&c=Index&a=comm`)
}

// 获取企业沿革列表
export function qyyg () {
  return axios.get(`${base}?m=Home&c=Qyyg&a=index`)
}

// 获取事业内容列表
export function synr () {
  return axios.get(`${base}?m=Home&c=Synr&a=index`)
}

// 获取商品列表
export function sp () {
  return axios.get(`${base}?m=Home&c=Sp&a=index`)
}

// 获取商品列表-首页
export function homeSp () {
  // return axios.get('http://1e27689s36.goho.co:22392/index/homeSp')
  return axios.get(`${base}?m=Home&a=homeSp&c=index`)
}

// 提交联系我们信息
export function add ({
  company, // 貴社名
  surname, // 姓
  name, // 名
  email, // email
  contact, // 联系方式，多个逗号分隔
  zipcode, // 邮便番号
  dudaofu, // 都道府县
  area, // 市区
  plate, // 门牌号
  apartment, // 公寓大楼名称
  remark // 洽谈内容
}) {
  const data = new FormData()
  const url = `${base}?m=Home&c=Lxwm&a=add`
  data.append('data', JSON.stringify({
    company, // 貴社名
    surname, // 姓
    name, // 名
    email, // email
    contact, // 联系方式，多个逗号分隔
    zipcode, // 邮便番号
    dudaofu, // 都道府县
    area, // 市区
    plate, // 门牌号
    apartment, // 公寓大楼名称
    remark // 洽谈内容
  }))
  return axios({
    method: 'post',
    url,
    data,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
